import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export default function HeroSectionPagination({ count, activeIndex, size = "md", onBulletClick, }) {
    const sizeStyles = React.useMemo(() => ({
        sm: {
            viewport: "h-5 w-17.5",
            track: "gap-1.5",
            bulletBase: "flex-none w-2 h-2 p-0 border-none rounded-full bg-[whitesmoke] cursor-pointer transition-[transform,outline-color,opacity] duration-300 ease-in-out",
            activeOutline: "outline outline-1 outline-offset-1 outline-[whitesmoke] scale-100",
        },
        md: {
            viewport: "h-6 w-22.5",
            track: "gap-2",
            bulletBase: "flex-none w-2.5 h-2.5 p-0 border-none rounded-full bg-[whitesmoke] cursor-pointer transition-[transform,outline-color,opacity] duration-300 ease-in-out",
            activeOutline: "outline outline-1 outline-offset-2 outline-[whitesmoke] scale-100",
        },
        lg: {
            viewport: "h-7 w-27.5", // (12px bullet + 10px gap) * 5 slots = 110px
            track: "gap-2.5",
            bulletBase: "flex-none w-3 h-3 p-0 border-none rounded-full bg-[whitesmoke] cursor-pointer transition-[transform,outline-color,opacity] duration-300 ease-in-out",
            activeOutline: "outline outline-1 outline-offset-3 outline-[whitesmoke] scale-100",
        },
    }), []);
    const styles = sizeStyles[size];
    const bulletStateClasses = React.useMemo(() => ({
        active: styles.activeOutline,
        prev: "scale-[0.8]",
        next: "scale-[0.8]",
        "prev-prev": "scale-[0.6]",
        "next-next": "scale-[0.6]",
        hidden: "scale-[0.4] opacity-40",
    }), [styles.activeOutline]);
    const viewportRef = React.useRef(null);
    const trackRef = React.useRef(null);
    React.useEffect(() => {
        const viewport = viewportRef.current;
        const track = trackRef.current;
        if (!viewport || !track)
            return;
        const bulletEl = track.children[activeIndex];
        if (!bulletEl)
            return;
        const bulletCenter = bulletEl.offsetLeft + bulletEl.offsetWidth / 2;
        const viewportCenter = viewport.clientWidth / 2;
        track.style.transform = `translateX(${viewportCenter - bulletCenter}px)`;
    }, [activeIndex, count, size]);
    return (_jsx("div", { ref: viewportRef, className: `pointer-events-auto flex items-center overflow-hidden ${styles.viewport}`, children: _jsx("div", { ref: trackRef, className: `flex items-center transition-transform duration-300 ease-in-out will-change-transform ${styles.track}`, children: Array.from({ length: count }).map((_, index) => {
                const distance = index - activeIndex;
                const state = distance === 0
                    ? "active"
                    : distance === -1
                        ? "prev"
                        : distance === 1
                            ? "next"
                            : distance === -2
                                ? "prev-prev"
                                : distance === 2
                                    ? "next-next"
                                    : "hidden";
                return (_jsx("button", { type: "button", "aria-label": `Slide ${index + 1}`, "aria-current": index === activeIndex, className: `${styles.bulletBase} ${bulletStateClasses[state]}`, onClick: () => onBulletClick(index) }, index));
            }) }) }));
}
